"use strict";

var InfiniteTree = require('./infinite-tree')["default"];

module.exports = InfiniteTree;